import { Component, OnInit } from '@angular/core';
import { BlobUploadsViewStateService } from '../services/blob-uploads-view-state.service';
import { Globals } from './../../globals'

@Component({
  selector: 'app-items-uploaded',
  template: `
    <ng-container *ngFor="let upload of uploads$ | async">
      <!--<pre *ngIf="upload.progress != 100">{{ upload | json }}</pre>-->
      <span class="form-paragraph" *ngIf="upload.progress != 100">{{upload.filename}}</span>
      <!--<mat-progress-bar mode="indeterminate" *ngIf="upload.progress != 100"></mat-progress-bar>-->
      <app-progress-bar [progress]="upload.progress" [total]="100" *ngIf="upload.progress != 100"></app-progress-bar>
    </ng-container>
  `
})

export class ItemsUploadedComponent implements OnInit {
  uploads$ = this.blobState.uploadedItems$;
  constructor(private blobState: BlobUploadsViewStateService,
    private globals: Globals) {
  }

  ngOnInit() {
  }
}
